import { useRouter } from "next/router";

import { Menu, Status } from "~components";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { Detail as DetailV2 } from "~features/events/components/EventDetails/EventDetails";
import { useGoogleAnalyticsPageView } from "~hooks/useGoogleAnalytics";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";
import { useEventAccessControl } from "~hooks/useEventAccessControl";
import HeaderAlert from "~components/common/common.HeaderAlert";
import { EventAccessStatus, VenueSeating } from "~graphql/sdk";

const EventInfoPage = () => {
  const router = useRouter();

  const {
    isLoading,
    event,
    error,
    release,
    accessType,
  } = useEventAccessControl();

  useCampaignReportingOpen(!isLoading);
  useGoogleAnalyticsPageView(router.query.eventId as string);
  useEventTrackingCodes();

  return (
    <>
      <Menu />
      <Status loading={isLoading} error={error}>
        {accessType === EventAccessStatus.AllowedAdminPreview && (
          <HeaderAlert
            paddingTop={2}
            message="Event preview"
            fixed={event.venue?.seating !== VenueSeating.Seated}
          />
        )}
        <DetailV2 event={event} release={release} />
      </Status>
    </>
  );
};

export default EventInfoPage;
